<lds-card padding="md">
  <div class="row">
    <div class="col">
      <h5>Provider settings</h5>
    </div>
    <div class="col-auto">
      <lds-icon-button icon="edit" appearance="default" [isRounded]="true" (onClick)="edit()">
      </lds-icon-button>
    </div>
  </div>
</lds-card>